import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FiChevronRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  font-size: 0.9rem;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const BreadcrumbItem = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const BreadcrumbLink = styled(Link)`
  color: var(--gray-dark);
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: var(--primary-color);
  }
`;

const CurrentItem = styled.span`
  color: var(--primary-color);
  font-weight: 500;
`;

const SeparatorIcon = styled.div`
  width: 16px;
  height: 16px;
  color: var(--gray-medium);
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface BreadcrumbProps {
  items: {
    label: string;
    path?: string;
  }[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const { t } = useTranslation();
  return (
    <BreadcrumbContainer aria-label={t('breadcrumb.navAriaLabel')} data-testid="breadcrumb-nav">
      {items.map((item, index) => (
        <BreadcrumbItem key={index}>
          {index > 0 && <SeparatorIcon><FiChevronRight /></SeparatorIcon>}
          {item.path ? (
            <BreadcrumbLink to={item.path}>{item.label}</BreadcrumbLink>
          ) : (
            <CurrentItem>{item.label}</CurrentItem>
          )}
        </BreadcrumbItem>
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;